import React, {useEffect} from 'react';
import {Helmet} from "react-helmet";
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import RegistrationForm from '../../components/common/RegistrationForm'
import FeaturesSideBySide from '../../components/features/FeaturesSideBySide'
import MaltaFeatures from '../../components/features/MaltaFeatures'
import Team from '../../components/team/Team'
import Pricing from '../../components/pricing/Pricing'
import Testimonials from '../../components/testimonials/Testimonials'
import Security from '../../components/security/Security'

import sixteenLogo from '../../assets/images/sixteen.png';
import myokaLogo from '../../assets/images/myoka.png';
import skySpiritLogo from '../../assets/images/sky-spirit.png';


function Home({

}) {


  return (

    <React.Fragment>

      <Helmet>
          <title>Buddy - Malta's Easiest Payroll Software</title>
          <meta name="description" content="Malta's easiest payroll software, learn how payroll can be easier. Free Demo Available." />
          <link rel="canonical" href={`https://www.buddy.hr`} />
          <html lang="en-MT" amp />
          <link rel="alternate" href="https://www.buddy.hr/uk" hrefLang="en-GB"/>
      </Helmet>
      <main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">
        <div className="mx-auto max-w-screen-xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
              <div>
                 {/*<Link to="/mt/cyber-monday" className="inline-flex items-center text-white bg-gray-900 rounded-full p-1 pr-2 sm:text-base lg:text-sm xl:text-base hover:text-gray-200">
                  <span className="px-3 py-0.5 text-white text-xs font-semibold leading-5 uppercase tracking-wide bg-orange-500 rounded-full">Cyber Week</span>
                  <span className="ml-4 text-sm leading-5">Up to 70% off Webinars & Courses</span>

                  <svg className="ml-2 w-5 h-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                  </svg>
                </Link>*/}
                 <Link to="/uk" className="inline-flex items-center text-white bg-gray-900 rounded-full p-1 pr-2 sm:text-base lg:text-sm xl:text-base hover:text-gray-200">
                  <span className="px-3 py-0.5 text-white text-xs font-semibold leading-5 uppercase tracking-wide bg-orange-500 rounded-full">UK Edition</span>
                  <span className="ml-4 text-sm leading-5">Click to discover payroll in other countries</span>

                  <svg className="ml-2 w-5 h-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                  </svg>
                </Link>
                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                  Malta's Easiest
                  <br />
                  <span className="text-orange-400">Payroll Solution</span>
                </h1>
                <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                  Buddy's easy to use payroll software is guaranteed to simplify and speed up your payroll process. Our software does all the heavy lifting, allowing you to focus on your business.
                </p>
                <p className="mt-8 text-sm text-white uppercase tracking-wide font-semibold sm:mt-10">Used by</p>
                <div className="mt-5 w-full sm:mx-auto sm:max-w-lg lg:ml-0">
                  <div className="flex flex-wrap items-start justify-between">
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={sixteenLogo} alt="Sixteen"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={myokaLogo} alt="Myoka Spas"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={skySpiritLogo} alt="Sky Spirit"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-span-6">
              <RegistrationForm/>
            </div>
          </div>
        </div>
      </main>

      <FeaturesSideBySide/>

      <div className="bg-orange-600">
        <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
          <h2 className="text-3xl leading-9 font-extrabold text-white sm:text-4xl sm:leading-10">
            <span className="block">Want to level-up your payroll?</span>
            <span className="block">Talk to an expert</span>
          </h2>
          <a target="_blank" href="https://calendly.com/buddy-intro/strategy" className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-orange-600 bg-white hover:text-orange-500 hover:bg-orange-50 transition duration-150 ease-in-out sm:w-auto">
            Schedule a call now
          </a>
          {/*<a href="tel:+35620331199,2" className="block text-white text-xs mt-4">
            or call on <span style={{textDecoration:"underline"}}>+356 2033 1199</span>  between 9am - 5pm
          </a>*/}
          <p className="mt-4 text-xs leading-1 text-orange-200">We'll take 15min of your time to understand if you're someone our payroll solution can help. <br/> This is a no-commitment call and comes at no charge.</p>
        </div>
      </div>

      <MaltaFeatures/>
      <Pricing/>
      <Testimonials/>
      <Security/>
      <Team/>


      <div className="bg-orange-600">
        <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
          <h2 className="text-3xl leading-9 font-extrabold text-white sm:text-4xl sm:leading-10">
            <span className="block">It's time to take your</span>
            <span className="block">Payroll to the next level.</span>
          </h2>
          <a target="_blank" href="https://calendly.com/buddy-intro/strategy" className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-orange-600 bg-white hover:text-orange-500 hover:bg-orange-50 transition duration-150 ease-in-out sm:w-auto">
            Book my spot
          </a>
          <p className="mt-4 text-xs leading-1 text-orange-200">We'll take 15min of your time to understand if you're someone our payroll solution can help. <br/> This is a no-commitment call and comes at no charge.</p>
        </div>
      </div>

    </React.Fragment>

  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home)
